module.exports = __webpack_public_path__ + "img/Yu.a43ac6ea.jpg";